import React from 'react';
import PivotTableUI from 'react-pivottable/PivotTableUI';
// https://stackoverflow.com/questions/59792418/pivot-table-fields-using-string-array
// arrays because the pivot table library uses arrays of strings
type Props = {
  data: any[];
  rows: string[];
  cols: string[];
  vals: string[];
  aggregatorName: string;
  setPivotStateParams: (next: {
    rows: string[];
    cols: string[];
    vals: string[];
    aggregatorName: string;
  }) => void;
};

class PivotApp extends React.Component<Props> {
  render() {
    const { data, rows, cols, vals, aggregatorName, setPivotStateParams } = this.props;

    return (
      <PivotTableUI
        data={data}
        rows={rows}
        cols={cols}
        vals={vals}
        aggregatorName={aggregatorName}
        onChange={(s: any) =>
          setPivotStateParams({
            // ensure arrays
            rows: Array.isArray(s.rows) ? s.rows : [],
            cols: Array.isArray(s.cols) ? s.cols : [],
            vals: Array.isArray(s.vals) ? s.vals : [],
            aggregatorName: s.aggregatorName || 'Sum',
          })
        }
      />
    );
  }
}

export default PivotApp;
